import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KeeniconComponent } from '../keenicon/keenicon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
	selector: 'app-select',
	templateUrl: './select.component.html',
	styleUrl: './select.component.scss',
	imports: [CommonModule, TranslateModule, KeeniconComponent, NgbDropdownModule, FormsModule, ReactiveFormsModule],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SelectComponent),
			multi: true,
		},
	],
})
export class SelectComponent implements OnChanges, ControlValueAccessor {
	@Input() multiSelect: boolean;
	@Input() multiSelectLevel: any;
	@Input() options: any;
	@Output() selectItemChange = new EventEmitter<any>();
	@Input() placeholder: string;
	@Input() selectedOption: any;
	@Input() bgColor: any;
	@Input() showDetails: boolean;
	@ViewChild(NgbDropdown) dropdown: NgbDropdown;
	@Output() isFocused: boolean;
	@Input() disabled: boolean | undefined = false;

	internalSelectedOption$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	private onChange = (_: any) => {};
	private onTouched = () => {};

	writeValue(value: any): void {
		this.selectedOption = value;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		// opcional
	}

	selectOption(option: any) {
		this.selectedOption = option;
		this.onChange(option);
		this.selectItemChange.emit(option);

		if (!this.selectedOption && option.name !== this.internalSelectedOption$.value?.name) {
			this.internalSelectedOption$.next(null);
			setTimeout(() => {
				this.internalSelectedOption$.next(option);
			}, 100);
		}

		if (!this.multiSelect && this.dropdown) {
			this.internalSelectedOption$.next(option);
			this.close();
		}
	}

	close() {
		this.dropdown.close();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['options']) {
			this.internalSelectedOption$.next(null);
			this.options = [];
			setTimeout(() => {
				this.options = changes['options'].currentValue;
			}, 150);
		}

		if (changes['selectedOption']) {
			this.internalSelectedOption$.next(null);
			setTimeout(() => {
				this.internalSelectedOption$.next(changes['selectedOption'].currentValue);
			}, 250);
		}
	}

	onFocus() {
		this.isFocused = true;
	}

	onBlur() {
		this.isFocused = false;
	}
}
